<!--
 * @Description: 认证回调
 * @Date: 2024-12-12 11:40:40
-->
<template>
  <div style="padding: 22px">
    <div
      style="
        font-weight: bold;
        text-align: left;
        font-size: 20px;
        margin-bottom: 15px;
        color: #121619;
      "
    >
      {{ title }}
    </div>

    <div style="font-size: 14px; color: #697077; line-height: 19px">
      更新日期：{{ date.dateFormat(releaseAt, 'Y-M-D') }}
    </div>
    <div
      style="
        margin-bottom: 23px;
        font-size: 14px;
        color: #697077;
        line-height: 19px;
      "
    >
      生效日期：{{ date.dateFormat(takeEffectAt, 'Y-M-D') }}
    </div>
    <p
      :innerHTML="content"
      style="
        word-break: break-all;
        font-size: 14px;
        color: #121619;
        line-height: 19px;
      "
    ></p>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { date } from 'xrk-tools';
import { useRoute } from 'vue-router';
import { getCommonProtocol } from '../data-source/api';
const route = useRoute();

const title = ref(); //标题
const takeEffectAt = ref(); //生效日期
const releaseAt = ref(); //更新日期
const content = ref(); //内容

const type = computed(() => +route.query.type - 1);
const getAgree = async () => {
  const { data } = await getCommonProtocol();
  title.value = data[type.value].title;
  content.value = data[type.value].content;
  takeEffectAt.value = data[type.value].takeEffectAt;
  releaseAt.value = data[type.value].releaseAt;
};
getAgree();
</script>
<style></style>
